import { useEffect, useState } from "react";
import { Monitor, Sparkles } from "lucide-react";
import { RichiestaDialog } from "./RichiestaAccesso";

export function DemoStrip({ info }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="sticky top-0 z-[70] bg-brand-greenDark text-brand-cream border-b-2 border-brand-gold" data-testid="demo-strip">
        <div className="flex items-center gap-3 px-4 lg:px-8 py-1.5 text-[12px]">
          <span className="font-bold tracking-[0.2em] text-brand-gold uppercase text-[10.5px] shrink-0">LEUTELIA Experience</span>
          <span className="hidden sm:inline text-brand-cream/80 truncate">· {info.hotel_name} · dati reali di analisi, sola lettura</span>
          <button onClick={() => setOpen(true)} data-testid="demo-scopri-btn" className="ml-auto shrink-0 flex items-center gap-1.5 rounded-full bg-brand-gold text-brand-greenDark px-3 py-1 text-[11.5px] font-semibold hover:bg-brand-cream transition-colors">
            <Sparkles size={13} /><span className="hidden md:inline">Scopri cosa LEUTELIA può individuare nel tuo hotel</span><span className="md:hidden">Il tuo hotel</span>
          </button>
        </div>
      </div>
      <RichiestaDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}

export function AvvisoSmartphone() {
  const [show, setShow] = useState(() => window.innerWidth < 768 && !sessionStorage.getItem("leu_demo_mobile_ok"));
  useEffect(() => { if (!show) sessionStorage.setItem("leu_demo_mobile_ok", "1"); }, [show]);
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[95] bg-brand-greenDark/85 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="demo-avviso-smartphone">
      <div className="w-full max-w-[420px] bg-brand-cream rounded-2xl border border-brand-gold/40 p-6 leu-in">
        <Monitor size={28} className="text-brand-gold" />
        <h2 className="font-serif text-[22px] text-brand-ink mt-3 leading-tight">Per grafici e analisi consigliamo un computer</h2>
        <p className="text-[13.5px] text-brand-muted mt-2">LEUTELIA Experience è pensata per lo schermo 16:9 del direttore. Da smartphone puoi comunque proseguire.</p>
        <button onClick={() => setShow(false)} data-testid="demo-avviso-prosegui" className="mt-5 w-full h-11 rounded-lg bg-brand-green text-brand-cream text-[14px] font-semibold">Prosegui lo stesso</button>
      </div>
    </div>
  );
}
